import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram as InstagramIcon } from 'lucide-react';

function Footer() {
  return (
    <footer className="bg-gray-900 border-t border-gray-800 text-white">
      <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-1">
            <img src="/bomb-puck-logo.png" alt="Bombardiers Hockey" className="h-16 mb-4" />
            <p className="text-gray-400 text-sm">
              Established in 2025, the Bombardiers Hockey program has been developing young hockey
              players in Ontario, California.
            </p>
          </div>

          <div>
            <h3 className="text-yellow-500 font-medium mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/team" className="text-gray-400 hover:text-white">
                  Team Roster
                </Link>
              </li>
              <li>
                <Link to="/schedule" className="text-gray-400 hover:text-white">
                  Schedule
                </Link>
              </li>
              <li>
                <Link to="/news" className="text-gray-400 hover:text-white">
                  News
                </Link>
              </li>
              <li>
                <Link to="/videos" className="text-gray-400 hover:text-white">
                  Training Videos
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-yellow-500 font-medium mb-4">Team Info</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/coaches" className="text-gray-400 hover:text-white">
                  Coaching Staff
                </Link>
              </li>
              <li>
                <Link to="/stats" className="text-gray-400 hover:text-white">
                  Statistics
                </Link>
              </li>
              <li>
                <Link to="/sponsors" className="text-gray-400 hover:text-white">
                  Sponsors
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-yellow-500 font-medium mb-4">Connect With Us</h3>
            <div className="flex space-x-4 mb-4">
              <a
                href="https://www.instagram.com/bombardiers_hockey_oyhl"
                className="text-gray-400 hover:text-white"
              >
                <span className="sr-only">Instagram</span>
                <div className="h-8 w-8 bg-gray-800 rounded-full flex items-center justify-center hover:bg-yellow-600">
                  <InstagramIcon className="h-4 w-4" />
                </div>
              </a>
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">© 2025 Bombardiers Hockey. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
